export default {
  title: "Kurzy",
  completed: "Dokončeno",
  startOver: "Začít znovu",
  detail: "Detail",
  begin: "Detail",
  play: "Detail kurzu",
  continue: "Pokračovat",
  buyAndPlay: "Koupit a hrát",
  backToJourney: "Zpět do kurzu",
};
